import {Rating, RatingProps} from "@mui/material"
import {styled} from "@mui/material/styles";

export const StyledRating = styled(Rating)<RatingProps>(({theme}) => ({
    '& .MuiRating-iconFilled': {
        color: "#e87474",
    },
    '& .MuiRating-iconHover': {
        color: "#cf3330",
    }
}))
